import { Component, OnDestroy, OnInit } from '@angular/core';
import { ConfigurationService } from '../../../services/configuration.service';
import { ActivatedRoute } from '@angular/router';
import { ProjectGeneralRouterService } from '../../../services/routes/dashboard/project/project-general-router.service';
import { ProjectStatusEnum } from '../../../models/defines';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'app-guest-finish',
    templateUrl: './guest-finish.component.html',
    styleUrl: './guest-finish.component.scss',
})
export class GuestFinishComponent implements OnInit, OnDestroy {
    congratsLottieAnimation = '/files/lottie-assets/congrats-animation.json';
    assetBasePath: string;
    projectId: string;
    private destroy$ = new Subject<void>();
    constructor(
        private config: ConfigurationService,
        private route: ActivatedRoute,
        private projectGeneralRouterService: ProjectGeneralRouterService
    ) {
        this.assetBasePath = this.config.baseCdnUrl;
    }

    ngOnInit(): void {
        this.route.queryParams.pipe(takeUntil(this.destroy$)).subscribe((params) => {
            this.projectId = params['projectId'];
        });
    }

    goBack() {
        this.projectGeneralRouterService.goToAsync(ProjectStatusEnum.PLANNING, this.projectId, true);
    }
    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
